import { render, staticRenderFns } from "./modal-proof-created-v2.vue?vue&type=template&id=46003a5b&scoped=true&"
import script from "./modal-proof-created-v2.vue?vue&type=script&lang=js&"
export * from "./modal-proof-created-v2.vue?vue&type=script&lang=js&"
import style0 from "./modal-proof-created-v2.vue?vue&type=style&index=0&id=46003a5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46003a5b",
  null
  
)

export default component.exports